// extracted by mini-css-extract-plugin
export default {"container":"WashMap_container__STCX2","inner":"WashMap_inner__h8MxR"};